/* eslint-disable import/prefer-default-export */
// This is the selector for the element that forms the root of the React app.
// As well as rendering to it, we need to let ReactModal know where it is.
export const APP_ROOT_SELECTOR = '#root';